import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M12 .429c6.39 0 11.571 5.18 11.571 11.571 0 6.39-5.18 11.571-11.571 11.571C5.61 23.571.429 18.391.429 12 .429 5.61 5.609.429 12 .429"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#D9DCDD",
  "stroke-width": ".85714",
  d: "M12 .429c6.39 0 11.571 5.18 11.571 11.571 0 6.39-5.18 11.571-11.571 11.571C5.61 23.571.429 18.391.429 12 .429 5.61 5.609.429 12 .429Z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#414042",
  d: "M17.143 7.897a1.04 1.04 0 0 0-1.774-.736l-.843.843 1.47 1.47.842-.842a1.04 1.04 0 0 0 .305-.735m-9.4 6.892h-.001a.6.6 0 0 0-.143.236L7 17l1.975-.598a.6.6 0 0 0 .236-.142l5.977-5.977-1.47-1.47zm10.543-6.892c0 .542-.203 1.064-.565 1.464l-.075.079-1.193 1.192a.6.6 0 0 1-.106.107l-6.327 6.329h-.001a1.7 1.7 0 0 1-.711.426h-.001l-2.487.755h-.002a.857.857 0 0 1-1.068-1.066v-.003l.756-2.487c.083-.27.23-.514.429-.712l6.326-6.328a.6.6 0 0 1 .106-.106l1.194-1.194.078-.074a2.183 2.183 0 0 1 3.647 1.618"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }